import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function WishlistButton({ sku, tenantSlug, size = "md" }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [active, setActive] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user?.role !== "customer") return;
    api.get("/wishlist/me").then((r) => {
      setActive(!!r.data.find((w) => w.sku_variante === sku && w.tenant_slug === tenantSlug));
    });
  }, [user, sku, tenantSlug]);

  const toggle = async (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (!user || user.role !== "customer") {
      navigate(`/login?redirect=${window.location.pathname}`);
      return;
    }
    setBusy(true);
    try {
      if (active) {
        await api.delete(`/wishlist/me?sku_variante=${sku}&tenant_slug=${tenantSlug}`);
        setActive(false);
        toast.success("Rimosso dai preferiti");
      } else {
        await api.post("/wishlist/me", { sku_variante: sku, tenant_slug: tenantSlug });
        setActive(true);
        toast.success("Aggiunto ai preferiti");
      }
    } catch (e) { toast.error("Errore"); } finally { setBusy(false); }
  };

  const cls = size === "sm" ? "w-8 h-8" : "w-10 h-10";
  return (
    <button data-testid={`wishlist-${sku}`} onClick={toggle} disabled={busy}
      className={`${cls} rounded-full border border-border bg-white hover:border-brand flex items-center justify-center transition-colors`}>
      <Heart className={`w-4 h-4 ${active ? "fill-red-500 text-red-500" : "text-foreground"}`} />
    </button>
  );
}
